/// <summary>
/// <br/>
/// Author: AFU<br />
/// Date: 20.1.2026<br />
/// Copyright ©: EUDT GmbH 2026 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 4.6.2026                                              *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>


jQuery.widget("bluaul.Dashboard", jQuery.common.vcBaseV4, {

    myData: { list: null, entry: null },
    myStatus: { status: null, signals: null },
   

    /**
     * Widget constructor. Registers this visual component with the framework
     * using type ID 407 (unique identifier for DailyPlausibility) and invokes
     * the parent class (vcBaseV4) constructor to set up inherited functionality.
     */
    _create: function () {
        this._createVisual(409);
        this._super();
    },

    _initHTML: function () {
        var me = this;
        try {

            
            // Locate the root container element by its CSS class.
            me._setRoot(".vc-dashboard-canvas");

            // Construct the full DOM tree (menu bar, list panel, detail panel).
            me._buildHtml();

            //only admins are allowed to add new dashboards
            if (me.specific.isAdmin) {
                me.myHtml.content.list.btnNewWrapper.show();
            }

            // Calculate and apply element dimensions relative to the visual's total size.
            me._setHeightsAndWidths();


        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
   

    _initStructure: function () {
        var me = this;
        try {

            _VCMQ.addConsumer(me.vcgid);
            _VCMQ.consume(me.visual, me.vcgid, function (event) {
                switch (event.msg) {
                    case 'DASHBOARD_REFRESH': 
                        me._fetch(); break;
                    default: break;
                } });



            //init settings popup
            me._initEditDialog(0.6, 0.5, "vc-dashboard", function () {
                me.editDialog.html("");
            });

            $("body").off("Trigger-vcMenu-BroadcastStatus.dashboard" + me.options.invoke.vcgid).on("Trigger-vcMenu-BroadcastStatus.dashboard" + me.options.invoke.vcgid, function (e) {
                if (e.value && e.value.status) {
                    me.myStatus.status = e.value.status;
                    me._onBroadcastStatus(e.value.status);
                }
            });

            $("body").off("Trigger-vcDashboard-Close.dashboard" + me.options.invoke.vcgid).on("Trigger-vcDashboard-Close.dashboard" + me.options.invoke.vcgid, function (e) {
                me._showEntry(me.myHtml.content.list.entries.find(".vc-list-item.selected"), true);
            });

            //clickhandler for new button
            me.myHtml.content.list.btnNew.off("click").on("click", function () {
                me._openEditDialog(-1, "edit");
            }).button();

            //clickhandler for entry list
            me.myHtml.content.list.entries.off("click", ".vc-list-item.found").on("click", ".vc-list-item.found", function () {

               
                me._showEntry($(this), true);
            });


            me.myHtml.content.list.entries.off("click", ".vc-list-item .icon-settings").on("click", ".vc-list-item .icon-settings", function (e) {
                var $item = $(this).closest(".vc-list-item");
                me._openEditDialog($item.data("id"), "edit");
                e.stopPropagation();
            });
            me.myHtml.content.list.entries.off("click", ".vc-list-item .icon-user").on("click", ".vc-list-item .icon-user", function (e) {
                var $item = $(this).closest(".vc-list-item");
                //VISUAL2_DASHBOARD_USER
 
                me._openEditDialog($item.data("id"), "user");
                e.stopPropagation();
            });

            me.myHtml.content.list.entries.off("click", ".vc-list-item .icon-canvas").on("click", ".vc-list-item .icon-canvas", function (e) {
                var $item = $(this).closest(".vc-list-item");
                me._showEntry($item, false);
                e.stopPropagation();
            });

            me.myHtml.content.list.entries.off("click", ".vc-list-item .icon-del").on("click", ".vc-list-item .icon-del", function (e) {
                var $item = $(this).closest(".vc-list-item");
                me._delete($item.data("id"));
                e.stopPropagation();
            });

           

        } catch (e) { me._writeErr(e); }
    },

    _buildHtml: function () {
        var me = this;
        try {
            // Master reference object holding all DOM element references for easy access.
            me.myHtml = {
                edit: {},
                content: {
                    list: {}, canvas: {} }
            };

            // ----- EDIT AREA -----
            obj = me.myHtml.edit;
            obj.wrapper = me._setObj("div-edit", "vc-grid-margin-right vc-grid-margin-bottom");

            obj.divName = me._setWrapper("div-name", "formItem formItemValid");
            obj.captionName = me._setObj("", "caption").html(me.specific.resources.name);
            obj.txtName = me._setInput("txt-name", "value edit").attr("type", "text");
            obj.divName.append(obj.captionName, obj.txtName);

            obj.divDescription = me._setWrapper("div-description", "formItem formItemValid");
            obj.captionDescription = me._setObj("", "caption").html(me.specific.resources.description);
            obj.txtDescription = me._setObj("txt-description", "value edit").attr("contenteditable", "true").css({ "min-height": "60px", "border": "1px solid #ddd", "padding": "4px" });
            obj.divDescription.append(obj.captionDescription, obj.txtDescription);

            obj.fieldset = me._setFieldset("div-edit-fieldset", "vc-grid-margin-bottom", me.specific.resources.settings);
            obj.fieldset.append(obj.divName, obj.divDescription);

            obj.wrapper.append(obj.fieldset);

            // ----- CONTENT AREA -----
            obj = me.myHtml.content;
            obj.wrapper = me._setObj("", "").css("width", "100%");
            
            obj = me.myHtml.content.list;
            obj.wrapper = me._setObj("", "vc-list vc-grid-2col float vc-grid-margin-right float-box");

            obj.btnNew = $("<div>").html(me.specific.resources.newEntry).css({  "margin": "8px 0 8px 0", "cursor": "pointer", "float": "right"});
            obj.btnNewWrapper = $("<div>").css("overflow", "hidden").append(obj.btnNew).hide();
            obj.entries = me._setObj("entries", "vc-list-table").css("border", "1px solid #ddd");
            obj.wrapper.append(obj.header, obj.btnNewWrapper, obj.entries);

            me.myHtml.content.canvas = me._setObj("", "float");
            

            me.myHtml.content.wrapper.append(me.myHtml.content.list.wrapper, me.myHtml.content.canvas);
            me.myRoot.append(me.myHtml.content.wrapper);


        } catch (e) { me._writeErr(e); return false; }
        return true;
    },



    _initEvents: function () {
        var me = this;
        try {

            me._initStructure();

            me._fetch();

        } catch (e) { me._writeErr(e); return false; }
        return true;

    },

    _showEntry: function (obj, readonly) {
        var me = this;
        try {
            me._setLoadingIcon(me.myHtml.content.canvas);
            me._toggleContent(readonly);

            me.myHtml.content.list.entries.find(".vc-list-item").removeClass("selected");
            obj.addClass("selected");

            //get the selected object
            me._setEntryById(obj.data("id"));

            var dashboardData = me.element.closest("[data-dashboard-data]").data("dashboardData") || me.element.data("dashboardData") || {};
            me.myStatus.status = dashboardData.status || null;
            me.myStatus.signals = dashboardData.signals || [];


            if (me.myStatus.status.date.interval !== me.myData.entry.StartInterval) {
                $("body").trigger({ type: "Trigger-vcMenu-SetInterval", vcgid: me.vcgid, value: me.myData.entry.StartInterval });
            }


            var config = me.myData.entry.Config.length > 0 ? JSON.parse(me.myData.entry.Config) : null;
           
            me.myHtml.content.canvas.vcDashboard({
                name: me.myData.entry.Name,
                id: me.myData.entry.Id, readonly: readonly, columns: me.myData.entry.Columns, rows: me.myData.entry.Rows,
                startConfig: config,
                LangId: me.settings.userLangIDForCulture,
                Signals: me.myStatus.signals || [],
                Status: me.myStatus.status,
                LoggerId: me.settings.blid,
                callback: function (fullConfig) {
                    me._saveConfig(fullConfig);
                }
            });

        } catch (e) { me._writeErr(e); }
    },

    _openEditDialog: function (id, type) {
        var me = this;
        try {
            me._setEntryById(id);
           
            me.editDialog.html($("<div>").attr("id", "div-dialogedit"));
           

            switch (type) {
                case "edit":
                    me.editDialog.dialog("option", "height", 530);
                    me.editDialog.dialog("option", "width", 500);
                    
                    me.editDialog.dialog("open");
                    me.vcV.addVisualBaseByName('div-dialo', "VISUAL_FORM_DASHBOARD_EDIT", "gedit", getCurrentTimestamp(), 445, 470, JSON.stringify({ "Id": id }), "", 1);
                    break;
                case "user":
                    me.editDialog.dialog("option", "height", 750);
                    me.editDialog.dialog("option", "width", 1000);
                    me.editDialog.dialog("open");
                    me.vcV.addVisualBaseByName('div-dialo', "VISUAL2_DASHBOARD_USER", "gedit", getCurrentTimestamp(), 680, 980, JSON.stringify({ "AssID": id }), "", 1);
                   
                    break;
                default:
            }

            




        } catch (e) { me._writeErr(e); }
    },

    _delete: function (id) {
        var me = this;
        try {
            me.myHtml.content.wrapper.css("opacity", 0.2);
            me.openAskDialog(
                (me.specific.resources.deleteEntry) + "?",
                { my: "center", at: "center", of: window },
                function () {
                    me.updateData({ TypeId: 2, Id: id }, function (result) {
                        me.myHtml.content.wrapper.css("opacity", 1);
                        if (result == null) {
                            me.showMessage(me.resources.err_saveData, true);
                            return true;
                        }
                        me._fetch();
                    });
                },
                function () {
                    me.myHtml.content.wrapper.css("opacity", 1);
                    return true;
                }
            );
        } catch (e) { me._writeErr(e); }
    },

    _setEntryById: function (id) {
        var me = this;
        me.myData.entry = (me.myData.list || []).find(function (e) { return e.Id == id; }) || null;
    },

    _toggleContent: function (readonly) {
        var me = this;
        try {
            if (me.error) { return false; }
            if (!readonly) {
                me.myHtml.content.list.wrapper.hide();
                me.myHtml.content.canvas.css("width", me._getVisualWidth() - 3);
            } else {
                me.myHtml.content.list.wrapper.show();
                me.myHtml.content.canvas.css("width", me._getVisualWidth() - me.myHtml.content.list.wrapper.outerWidth() - 20);
            }


        } catch (e) { me._writeErr(e); return false; }
        return true;
    },


    _saveConfig: function (config) {
        var me = this;
        try {
            var sConfig = JSON.stringify(config);
            me.updateData({ TypeId: 1, Id: me.myData.entry.Id, Config: sConfig }, function (result) {
                if (result == null) {
                    me.showMessage(me.resources.err_saveData, true);
                    return true;
                }
                var entry = me.myData.list.find(function (e) { return e.Id == me.myData.entry.Id; }); 
                if (entry) {
                    entry.Config = sConfig;
                }
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
   

    _fetch: function () {
        var me = this;
        try {
            // Show a loading indicator in the entry list while waiting for the response.
            me._setLoadingIcon(me.myHtml.content.list.entries);

            // AJAX call to the server-side getData method.
            // TypeId 1 corresponds to the "fetch entries" case in the C# switch statement.
            me.getData({ TypeId: 1 }, function (result) {
                // Store the fetched signal data.
                me.myData.list = result;

                if (me.myData.list === null || me.myData.list.length == 0) {
           
                    me.myHtml.content.list.entries.html($("<div>").addClass("note").html(me.resources.noEntriesExist));
                    me.myHtml.content.canvas.html("");
                    return false;
                }

                me._generateList();

                var obj = me.myHtml.content.list.entries.find(".vc-list-item.menu-item").first();

                if (me.myData != null) {
                    if (me.myData.entry != null) {
                        if (me.myData.entry.Id != -1) {
                            me.myHtml.content.list.entries.find(".vc-list-item.menu-item").filter(function () {
                                return $(this).data("id") == me.myData.entry.Id;
                            }).addClass("selected");

                            obj = me.myHtml.content.list.entries.find(".vc-list-item.selected.menu-item");
                            if (obj.length === 0) {
                                obj = me.myHtml.content.list.entries.find(".vc-list-item.menu-item").first();
                            }
                        }
                    }
                }


               me._showEntry(obj, true);
            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },


    _generateList: function () {
        /// <summary>
        /// This function generates the table and fills the list with data, grouped by GroupName
        /// </summary>
        var me = this;
        try {

            //clear list
            me.myHtml.content.list.entries.html("");

            // group entries by GroupName
            var groups = {};
            for (var i = 0; i < me.myData.list.length; i++) {
                var groupName = me.myData.list[i].GroupName || "";
                if (!groups[groupName]) {
                    groups[groupName] = [];
                }
                groups[groupName].push(me.myData.list[i]);
            }

            // sort group keys by name
            var sortedKeys = Object.keys(groups).sort(function (a, b) {
                return a.localeCompare(b);
            });

            // build grouped list
            var groupIndex = 0;
            for (var k = 0; k < sortedKeys.length; k++) {
                var key = sortedKeys[k];
                if (!groups.hasOwnProperty(key)) continue;

                var $groupHeader = $("<div>").addClass("vc-list-header color-bg-secondary").css("cursor", "pointer");
                var $headerLine = $("<div>").addClass("vc-list-item");
                var $headerCol = $("<div>").addClass("vc-list-col");
                var $arrow = $("<i class='fa-solid fa-chevron-down vc-group-arrow'></i>").css("margin-right", "6px");
                $headerCol.append($("<div>").addClass("vc-list-col-element").append($arrow).append(key || "-"));
                $headerLine.append($headerCol);
                $groupHeader.append($headerLine);

                var $groupItems = $("<div>").addClass("vc-list-table vc-group-items");

                for (var j = 0; j < groups[key].length; j++) {
                    me._fillRow(groups[key][j], $groupItems);
                }

                // toggle group on header click
                (function ($header, $items, $arrowRef) {
                    $header.on("click", function () {
                        $items.slideToggle(150);
                        $arrowRef.toggleClass("fa-chevron-right fa-chevron-down");
                    });
                })($groupHeader, $groupItems, $arrow);

                me.myHtml.content.list.entries.append($groupHeader, $groupItems);
                groupIndex++;
            }

            me._setAltListStyle(me.myHtml.content.list.entries);
            return true;

        } catch (e) {
            me._writeErr(e);
            return false;
        }
    },

    _fillRow: function (row, $container) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {
            var $target = $container || me.myHtml.content.list.entries;

            var line = me._setListItem();
            line.item.addClass("found menu-item").data("id", row.Id);
            var name = row.Name;
            if (row.Edit) {
                name += "<br/><span style='font-size:smaller'>(" + row.CreatorName + ")</span>";
            }
            line.column.append(me._setListElement("", row.Edit ? "w70" : "").html(name));



            if (row.Edit) {
                var icons = $("<div>");
                
                icons.append("<i class='icon-settings fa fa-gear icon-color-info' title='settings'></i>");
                if (row.UserEdit) { icons.append("<i class='icon-user fa fa-user-group icon-color-info' title='user'></i>"); }
                icons.append("<i class='icon-canvas fa fa-diagram-lean-canvas icon-color-info ' title='edit'></i>");
                icons.append("<i class='icon-del fa fa-times icon-color-error' title='delete'></i>");


                icons.find(".fa").css("font-size", "15px").css("margin-left", "5px");
                line.column.append(me._setListElement("", "").css("float", "right").html(icons));
            }
            $target.append(line.item);

            return true;
        } catch (e) { me._writeErr(e); return false; }
    },


   
    
    /**
     * Calculates and applies responsive heights to all major layout containers.
     * The available content height is determined by subtracting the menu bar height
     * and padding from the total visual height provided by the framework.
     *
     * Applied to:
     *   - Content wrapper: Overall content area below the menu.
     *   - List wrapper: The list panel container.
     *   - List entries: The scrollable entry area (slightly reduced for the header).
     *   - Detail wrapper: The edit form panel (same height as list for consistent layout).
     *
     * @returns {boolean} true if heights were set, false if the widget is in an error state.
     */
    _setHeightsAndWidths: function () {
        var me = this;
        try {
            if (me.error) { return false; }
           
            let hList = me._getVisualHeight();
           
            // Apply the calculated height to both content columns.
            me.myHtml.content.wrapper.css("height", hList);
            me.myHtml.content.list.wrapper.css("height", hList);
            me.myHtml.content.list.entries.css("height", hList - me.myHtml.content.list.btnNew.outerWidth() -  31);
            me.myHtml.content.canvas.css("height", hList - 8);
            me.myHtml.content.canvas.css("width", me._getVisualWidth() - me.myHtml.content.list.wrapper.outerWidth() - 20);
         

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    /**
     * Handles error display states for the widget.
     * When an error occurs (bError=true), both the menu bar and content area are hidden,
     * leaving only the framework's error message visible to the user.
     * This ensures a clean UI when the widget cannot function due to missing data or server errors.
     *
     * Called by the framework's built-in error handling mechanism (inherited from vcBaseV4).
     *
     * @param {boolean} bError - true if an error state should be shown, false otherwise.
     * @returns {boolean} true on success, false on error.
     */
    _onBroadcastStatus: function (status) {
        var me = this;
        try {
            me.myStatus.status = status;
            var api = me.myHtml.content.canvas.data("vcDashboard");
            if (api && api.updateStatus) {
                api.updateStatus(status);
            }
        } catch (e) { me._writeErr(e); }
    },


    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                // Hide both menu and content to show only the error message.
                me.myHtml.content.wrapper.hide();
            }

        } catch (e) { me._writeErr(e); return false; }
        return true;
    }
});